import React, { useEffect } from "react";
import { Slider as Rangebar } from "antd";
import dayjs from "dayjs";

export default function Step3SetTime({ formData, setFormData }) {
  const schedule_days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  useEffect(() => {
    // Only set defaults if days or time are not set
    if (
      !formData.schedule_days ||
      formData.schedule_days.length === 0 ||
      !formData.schedule_start_time ||
      !formData.schedule_end_time
    ) {
      setFormData((prev) => ({
        ...prev,
        schedule_days:
          prev.schedule_days && prev.schedule_days.length > 0
            ? prev.schedule_days
            : ["Mon", "Tue", "Wed", "Thu", "Fri"],
        schedule_start_time: prev.schedule_start_time || "09:00",
        schedule_end_time: prev.schedule_end_time || "19:00",
      }));
    }
  }, [
    formData.schedule_days,
    formData.schedule_start_time,
    formData.schedule_end_time,
    setFormData,
  ]);

  const timeToMinutes = (timeStr) => {
    if (!timeStr) return 0;
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
  };

  const minutesToTime = (minutes) => {
    const h = String(Math.floor(minutes / 60)).padStart(2, "0");
    const m = String(minutes % 60).padStart(2, "0");
    return `${h}:${m}`;
  };

  const formatDisplayTime = (timeStr) =>
    dayjs(`2000-01-01 ${timeStr}`).format("hh:mm A");

  const sliderValue = [
    timeToMinutes(formData.schedule_start_time || "09:00"),
    timeToMinutes(formData.schedule_end_time || "19:00"),
  ];

  return (
    <>
      <h4>Set Day and Time</h4>
      <p className="formTitle mt-3 mb-4">
        Choose the day(s) and time this event should be active.
      </p>

      <label className="mb-2">Days of the Week</label>
      <div className="weekCheckBox">
        {schedule_days.map((day) => (
          <div
            key={day}
            className={`itemsCheck ${
              formData.schedule_days.includes(day) ? "select" : ""
            }`}
            onClick={() => {
              setFormData((prev) => {
                const selected = prev.schedule_days.includes(day)
                  ? prev.schedule_days.filter((d) => d !== day)
                  : [...prev.schedule_days, day];
                return { ...prev, schedule_days: selected };
              });
            }}
          >
            {day}
          </div>
        ))}
      </div>

      <div className="row mt-4">
        <div className="col-6">
          <Rangebar
            range
            min={0}
            max={1440}
            step={15}
            value={sliderValue}
            onChange={(val) => {
              const [startMin, endMin] = val;
              setFormData((prev) => ({
                ...prev,
                schedule_start_time: minutesToTime(startMin),
                schedule_end_time: minutesToTime(endMin),
              }));
            }}
          />
          <div className="text-center mt-2 fw-bold">
            {formatDisplayTime(formData.schedule_start_time || "09:00")} -{" "}
            {formatDisplayTime(formData.schedule_end_time || "19:00")}
          </div>
        </div>
      </div>
    </>
  );
}
